import React from "react";
import "./City_Guard.css";
import Common_Back_Header from "../../../common_components/common_back_btn/Common_Back_Btn";
import Common_Title from "../../../common_components/common_title/Common_Title";

const City_Guard = () => {
  return (
    <section className="City_Guard">
      <div className="container">
        <Common_Back_Header backNavigation={-1}/>

        <Common_Title
          title={"CERTIGUARD"}
          subtitle={
            "Silver-based Antimicrobial which reduces the growth of unwanted microbes in the mattress and gives safe, clean, and healthy sleep."
          }
        />

        <div className="main_content_div">
          <div className="common_gray_div">
            <p className="common_section_title">USP</p>
            <div className="inner_content_div">
              <p className="p_text">
                <ul class="usp_list">
                  <li>Multistage Technology.</li>
                  <li>Increases productivity and concentration.</li>
                  <li>99.9% Germ-free sleep.</li>
                  <li>Permanently integrated into the fibres and foam.</li>
                  <li>Control the growth of unwanted microbes.</li>
                  <li>Resist high-temperature and low colour formation.</li>
                  <li>Silver-based Antimicrobial properties.</li>
                  <li>Promotes good health.</li>
                  <li>
                    Value addition to your mattress at no additional cost.
                  </li>
                  <li>100% environmentally friendly.</li>
                  <li>Odour-free.</li>
                  <li>Best available technology in the market today.</li>
                </ul>
              </p>
            </div>
          </div>

          <div className="common_gray_div">
            <p className="common_section_title">Fact</p>
            <div className="inner_content_div">
              <p className="p_text">
                There are up to 10,000 dust mites living in one gram of dust. An
                average person loses up to 1.5 litres of sweat and about 1.5
                grams of dandruff every night making your mattress the perfect
                breeding space for micro-organisms.
              </p>
            </div>
          </div>

          <div className="common_gray_div">
            <p className="common_section_title">Punch Lines</p>
            <div className="inner_content_div">
              <p className="p_title">
                Breathe Deeper, Live Better: The Majesty Certiguard Revolution
              </p>
              <p className="p_text bottom_space">
                Elevate your sleep hygiene with Majesty Certiguard Technology,
                the gold standard for a germ-free, rejuvenating rest. In a
                post-pandemic world, we understand that safety isn't just an
                outdoor concern—it starts in the sanctuary of your bedroom.
              </p>

              <p className="p_title">The Silent Obstacle to Success</p>
              <p className="p_text bottom_space">
                For many Indian households, invisible dust mites and allergens
                are the secret culprits behind a restless night. Scientific
                research proves that poor sleep quality is directly tied to a
                drop in daily productivity and mental clarity. While the modern,
                fast-paced lifestyle often neglects the vital link between rest
                and performance, Majesty bridges that gap by prioritizing your
                health as much as your comfort.
              </p>
            </div>
          </div>

          <div className="common_gray_div">
            <p className="common_section_title">
              Why Choose Majesty Certiguard?
            </p>
            <div className="inner_content_div">
              <p className="p_title remove_space">
                Total Environmental Defense:
              </p>
              <p className="p_text bottom_space">
                Our multistage technology is permanently integrated into the
                mattress fibers and foam. It doesn't just mask allergens; it
                actively reduces and removes them at the source.
              </p>

              <p className="p_title remove_space">Naturally Cool & Pristine:</p>
              <p className="p_text bottom_space">
                Certiguard ensures your sleep surface remains fresh and
                breathable, resisting the buildup of heat and bacteria.
              </p>

              <p className="p_title remove_space">Long-Lasting Purity:</p>
              <p className="p_text bottom_space">
                Because our protection is built into the core materials, your
                mattress remains a safe haven for its entire lifespan—making it
                a truly sustainable choice for your home.
              </p>

              <p className="p_title remove_space"> Performance-Driven Rest:</p>
              <p className="p_text bottom_space">
                By removing the physical obstacles to deep sleep, we empower you
                to wake up with the focus & energy required to meet your daily
                goals.
              </p>
            </div>
          </div>

          <div className="common_gray_div">
            <p className="normal_text">
              Think of it this way: you wouldn't put on fresh clothes without
              showering first, right? Yet, many of us diligently wash our linens
              while the mattress — the very foundation of our sleep—remains
              untouched and uncleaned for years.
            </p>

            <p className="normal_text">
              {" "}
              Over time, an unprotected mattress becomes a reservoir for
              unsanitary particles, posing real health risks to your family.
              From chronic asthma & persistent allergies to general respiratory
              discomfort, the air you breathe while you sleep is only as clean
              as the mattress beneath you.
            </p>

            <div className="inner_content_div">
              <p className="p_title">
                The Majesty Defense: Advanced Silver-Ion Protection
              </p>
              <p className="p_text bottom_space">
                To ensure your sanctuary remains truly healthy, Majesty
                integrates the most sophisticated silver-based antimicrobial
                systems directly into our mattresses. We believe that fitness
                begins with a clean sleep environment.
              </p>

              <p className="p_title">
                Why Majesty CertiGuard is a Game-Changer:
              </p>
              <p className="p_text bottom_space">
                Silver-Powered Purity: We utilize the natural antimicrobial
                properties of silver—a material trusted in medical and
                human-contact applications - to neutralize a broad spectrum of
                odor-causing microbes and bacteria.
              </p>

              <p className="p_title">
                The Five-Fold Shield: Our CertiGuard technology ensures every
                Majesty mattress is:
              </p>
              <p className="p_text ">
                Antimicrobial: Actively kills germs on contact.
              </p>
              <p className="p_text ">
                Hypoallergenic: Safe for sensitive skin and lungs.
              </p>
              <p className="p_text ">
                Dust Mite Resistant: Creates a hostile environment for common
                allergens.
              </p>
              <p className="p_text ">
                Odor-Free: Prevents the buildup of stale scents and biofouling.
              </p>
              <p className="p_text ">
                Eco-Friendly: Sustainable materials for a healthier planet.
              </p>

              <div className="bottom_text">
                <p className="p_title">Protection That Never Fades</p>
                <p className="p_text bottom_space">
                  Unlike topical sprays or temporary treatments, Majesty’s
                  protection is built into the fibers and foam. It cannot be
                  washed out or worn away. It remains active for the entire
                  lifespan of your mattress, inhibiting stains and discoloration
                  while maintaining the aesthetic and hygienic integrity of your
                  bed.
                </p>

                <p className="p_title">Reclaim Your Sleep Hygiene</p>
                <p className="p_text bottom_space">
                  While microbes are a fact of nature, they don't have to be a
                  part of your bed. By combining simple hygiene habits with
                  Majesty’s built-in antimicrobial defense, you can finally
                  enjoy the deep, worry-free sleep you deserve.
                </p>
              </div>
            </div>
          </div>

          <div className="common_gray_div">
            <p className="common_section_title">
              Sleep Fit, Stay Fit with Springfit Certiguard Technology
            </p>
            <div className="inner_content_div">
              <p className="p_title remove_space">Continuous Microbial Defense:</p>
              <p className="p_text bottom_space">
                Our Certiguard technology acts as a permanent shield, preventing
                bacteria and microbes from colonizing your mattress. Whether
                transferred from your skin or the air, these organisms are
                stopped before they can reproduce.
              </p>

              <p className="p_title remove_space">Deep-Core Integration:</p>
              <p className="p_text bottom_space">
                Unlike surface treatments, Majesty’s multistage protection is
                woven directly into the fabric and fused within the foam. This
                ensures a comprehensive, long-lasting barrier that keeps the
                interior as clean as the exterior.
              </p>

              <p className="p_title remove_space">Health-Driven Performance:</p>
              <p className="p_text bottom_space">
                A clean mattress is the secret to a sharp mind. By eliminating
                allergens and germs, Majesty fosters the high-quality rest
                necessary for peak concentration and daily productivity.
              </p>

              <p className="p_title remove_space">Breathe and Restore:</p>
              <p className="p_text bottom_space">
                Experience the peace of mind that comes with certified germ-free
                sleep products. With Majesty, you aren't just sleeping; you're
                rejuvenating in a fresh, temperature-regulated sanctuary.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default City_Guard;
